export default "__VITE_ASSET__CHUKZuhl__"